import React, {Component, Fragment} from "react"

import Card from "@irati/ui/src/Layout/Card"

import {votesQuery} from "@irati/recognition/apollo/query/Votes"
import {accountRecognitionsQuery} from "@irati/recognition/apollo/query/AccountRecognitions"
import {DisablePointerEventsOnScroll} from "@irati/ui/src/Feed"
import authentication from "@irati/auth"
import tracking from "@irati-tracking/recognition/navigation"
import {SENT, RECEIVED} from "@irati/recognition/constants/sentAndReceived"
import {feedPollQuery} from "@irati/recognition/apollo/query/FeedPoll"
import {feedRecognitionQuery} from "@irati/recognition/apollo/query/FeedRecognition"
import {Query} from "@irati/utils/services/apollo"
import ErrorPopup from "../../../components/Popup/Error"
import VotesPopup from "../../../components/Popup/Votes"
import RecognitionPopup from "../../../components/Popup/Recognition"
import Recognition from "./Recognition"
import Votes from "./Votes"

const RECOGNITION_TAB = "recognition"
const VOTES_TAB = "votes"

interface Props {
  showVotes?: boolean
}

class MyRecognition extends Component<Props> {
  constructor(props: Props) {
    super(props)
    this.state = {
      showTab: RECOGNITION_TAB,
      pollId: null,
      recognitionId: null,
      votesVariables: votesQuery.variables,
      recognitionsVariables: accountRecognitionsQuery.variables
    }
  }

  static defaultProps = {
    id: "myRecognition"
  }

  componentDidMount() {
    tracking.viewProfile()
  }

  isEmpty(accountTrophies) {
    return accountTrophies.results.length === 0
  }

  handleLabelClick = (tab) => {
    this.setState({
      showTab: tab
    })
  }

  handleClickCard = (obj) => {
    if (this.state.showTab === VOTES_TAB) {
      this.setState({pollId: obj.poll.uuid})
    } else {
      this.setState({recognitionId: obj.uuid})
    }
  }

  handleAfterExitModal = () => {
    this.setState({
      pollId: null,
      recognitionId: null
    })
  }

  handleVisibilityChange = (view) => {
    const to = view === RECEIVED ? authentication.user().uuid : null
    const from = view === SENT ? authentication.user().uuid : null

    this.setState({
      votesVariables: {...votesQuery.variables, to, from},
      recognitionsVariables: {...accountRecognitionsQuery.variables, to, from}
    })
  }

  render() {
    const {pollId, recognitionId, votesVariables, recognitionsVariables} = this.state
    const {showVotes} = this.props
    const votesProps = {...votesQuery, variables: votesVariables}
    const recognitionsProps = {...accountRecognitionsQuery, variables: recognitionsVariables}

    return (
      <Fragment>
        <Card tiny noBorder>
          <DisablePointerEventsOnScroll>
            {showVotes ?
              <Votes handleClickCard={this.handleClickCard} votes={votesProps} /> :
              <Recognition handleClickCard={this.handleClickCard} recognitions={recognitionsProps} />}
          </DisablePointerEventsOnScroll>
        </Card>
        {pollId && (
          <Query query={feedPollQuery.query} variables={{id: pollId}} Error={ErrorPopup}>
            {({data: {poll}}) => (
              <VotesPopup poll={poll} showViewVotes={!poll.active} onAfterExitModal={this.handleAfterExitModal} />
            )}
          </Query>
        )}
        {recognitionId && (
          <Query query={feedRecognitionQuery.query} variables={{id: recognitionId}} Error={ErrorPopup}>
            {({data: {recognition}}) => (
              <RecognitionPopup recognition={recognition} onAfterExitModal={this.handleAfterExitModal} />
            )}
          </Query>
        )}
      </Fragment>
    )
  }
}

export default MyRecognition
